// address/address.schema.ts
import { z } from "zod";
var AddressSchema = z.object({
  id: z.string(),
  address1: z.string().min(1, { message: "Address 1 is required" }),
  address2: z.string().optional(),
  city: z.string().min(1, { message: "City is required" }),
  state: z.string().min(1, { message: "State is required" }),
  zip: z.string().min(1, { message: "Zip code is required" }),
  company: z.string().optional(),
  isDefault: z.boolean().optional()
});
var DbAddressSchema = z.object({
  id: z.string(),
  address1: z.string().min(1, { message: "Address 1 is required" }),
  address2: z.string().optional(),
  city: z.string().min(1, { message: "City is required" }),
  state: z.string().min(1, { message: "State is required" }),
  zip: z.string().min(1, { message: "Zip code is required" }),
  company: z.string().optional(),
  is_default: z.boolean().optional()
});
var AddressDtoSchema = z.object({
  id: z.string(),
  address1: z.string().min(1, { message: "Address 1 is required" }),
  address2: z.string().optional(),
  city: z.string().min(1, { message: "City is required" }),
  state: z.string().min(1, { message: "State is required" }),
  zip: z.string().min(1, { message: "Zip code is required" }),
  company: z.string().optional(),
  isDefault: z.boolean().optional()
});
var CreateAddressDtoSchema = z.object({
  address1: z.string().min(1, { message: "Address 1 is required" }),
  address2: z.string().optional(),
  city: z.string().min(1, { message: "City is required" }),
  state: z.string().min(1, { message: "State is required" }),
  zip: z.string().min(1, { message: "Zip code is required" }),
  company: z.string().optional()
});
var B2BWaveAddressSchema = z.object({
  id: z.number(),
  address: z.string(),
  address2: z.string().nullable(),
  city: z.string(),
  province: z.string(),
  country: z.string(),
  postal_code: z.string(),
  phone: z.string().nullable(),
  address_type: z.string(),
  customer_id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  last_used_at: z.string().nullable(),
  title: z.string()
});
var CreateB2BWaveAddressSchema = z.object({
  address: z.string().optional(),
  address2: z.string().optional(),
  city: z.string().optional(),
  province: z.string().optional(),
  country: z.string().optional(),
  postal_code: z.string().optional(),
  phone: z.string().optional(),
  reference_code: z.string().optional(),
  customer_id: z.number()
});
var B2BWaveAddressBookSchema = z.array(B2BWaveAddressSchema);
var B2BWaveAddressDtoSchema = z.object({
  id: z.number(),
  address: z.string(),
  address2: z.string().nullable(),
  city: z.string(),
  province: z.string(),
  country: z.string(),
  postalCode: z.string(),
  phone: z.string().nullable(),
  addressType: z.string(),
  customerId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastUsedAt: z.string().nullable(),
  title: z.string()
});
var CreateB2BWaveAddressDtoSchema = z.object({
  address: z.string().optional(),
  address2: z.string().nullable(),
  city: z.string().optional(),
  province: z.string().optional(),
  country: z.string().optional(),
  postalCode: z.string().optional(),
  phone: z.string().optional(),
  referenceCode: z.string().optional(),
  customerId: z.number()
});
export {
  AddressDtoSchema,
  AddressSchema,
  B2BWaveAddressBookSchema,
  B2BWaveAddressDtoSchema,
  B2BWaveAddressSchema,
  CreateAddressDtoSchema,
  CreateB2BWaveAddressDtoSchema,
  CreateB2BWaveAddressSchema,
  DbAddressSchema
};
